"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _nenhumaImagem = _interopRequireDefault(require("../imagens/quantidadeImagensPagina/nenhumaImagem.png"));
var _umaImagens = _interopRequireDefault(require("../imagens/quantidadeImagensPagina/umaImagens.png"));
var _duasImagens = _interopRequireDefault(require("../imagens/quantidadeImagensPagina/duasImagens.png"));
var _quatroImagens = _interopRequireDefault(require("../imagens/quantidadeImagensPagina/quatroImagens.png"));
var _seisImagens = _interopRequireDefault(require("../imagens/quantidadeImagensPagina/seisImagens.png"));
var _oitoImagens = _interopRequireDefault(require("../imagens/quantidadeImagensPagina/oitoImagens.png"));
var _styles = require("@material-ui/core/styles");
var _core = require("@stt-componentes/core");
var _Add = _interopRequireDefault(require("@material-ui/icons/Add"));
var _Remove = _interopRequireDefault(require("@material-ui/icons/Remove"));
var _axios = _interopRequireDefault(require("axios"));
var _reactNotifications = require("react-notifications");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    previewWrapper: {
      display: "flex",
      justifyContent: "center",
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1)
    },
    previewImagens: {
      maxWidth: "100%",
      maxHeight: "100%",
      objectFit: "contain"
    },
    linhaControle: _defineProperty({
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      gap: theme.spacing(2),
      marginTop: theme.spacing(1),
      flexWrap: "wrap"
    }, theme.breakpoints.down("sm"), {
      justifyContent: "center"
    }),
    grupoBotoes: {
      display: "flex",
      alignItems: "center",
      gap: theme.spacing(1),
      flexWrap: "wrap"
    },
    botaoCircular: {
      minWidth: 40,
      minHeight: 40,
      borderRadius: 20,
      padding: 0
    },
    box: {
      minWidth: 56,
      height: 40,
      borderRadius: 8,
      border: "1px solid ".concat(theme.palette.text.primary),
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      marginLeft: theme.spacing(1)
    },
    botaoConfirmar: {
      minWidth: 140
    },
    tituloMensagem: {
      color: theme.palette.primary.main,
      fontWeight: 600,
      marginBottom: 8
    }
  };
});
var OPCOES_IMAGENS_POR_PAGINA = [0, 1, 2, 4, 6, 8];
var paginaImagens = {
  0: _nenhumaImagem["default"],
  1: _umaImagens["default"],
  2: _duasImagens["default"],
  4: _quatroImagens["default"],
  6: _seisImagens["default"],
  8: _oitoImagens["default"]
};
var SttModalImpressao = function SttModalImpressao(props) {
  var setAbrirModalImpressao = props.setAbrirModalImpressao,
    setLoading = props.setLoading,
    setLoadingMessage = props.setLoadingMessage,
    loading = props.loading,
    config = props.config,
    abrirModalImpressao = props.abrirModalImpressao,
    carregando = props.carregando;
  var _useContext = (0, _react.useContext)(_core.SttTranslateHook.I18nContext),
    strings = _useContext.strings;
  var classes = useStyles();
  var _useState = (0, _react.useState)(0),
    _useState2 = _slicedToArray(_useState, 2),
    quantidadeImagens = _useState2[0],
    setQuantidadeImagens = _useState2[1];
  var imprimirFn = function imprimirFn() {
    if (setLoadingMessage) {
      setLoadingMessage(strings.gerandoDocumento);
    }
    if (carregando !== undefined) {
      carregando.value = {
        open: true,
        descricao: strings.gerandoDocumento
      };
    } else {
      setLoading(true);
    }
    var idExameCodificado = Buffer.from(config.idExame.toString()).toString("base64");
    config.opcoes.params = _objectSpread(_objectSpread({}, config.opcoes.params), {}, {
      imagens: true,
      quantidade_imagens: quantidadeImagens
    });
    _axios["default"].get("".concat(config.url, "/exame/").concat(idExameCodificado, "/imprimir"), config.opcoes).then(function (response) {
      if (response.data) {
        if (Array.isArray(response.data)) {
          var _iterator = _createForOfIteratorHelper(response.data),
            _step;
          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var url = _step.value;
              console.log(url);
              window.open(url);
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
          return;
        }
        window.open(response.data);
      }
    })["catch"](function (err) {
      console.log(err);
      _reactNotifications.NotificationManager.error(err.message);
    })["finally"](function () {
      if (carregando !== undefined) {
        carregando.value = {
          open: false
        };
      } else {
        setLoading(false);
      }
      fecharModal();
    });
  };
  var indiceAtual = function indiceAtual() {
    var idx = OPCOES_IMAGENS_POR_PAGINA.indexOf(quantidadeImagens);
    return idx === -1 ? 0 : idx;
  };
  var incrementar = function incrementar() {
    var idx = indiceAtual();
    if (idx < OPCOES_IMAGENS_POR_PAGINA.length - 1) {
      setQuantidadeImagens(OPCOES_IMAGENS_POR_PAGINA[idx + 1]);
    }
  };
  var decrementar = function decrementar() {
    var idx = indiceAtual();
    if (idx > 0) {
      setQuantidadeImagens(OPCOES_IMAGENS_POR_PAGINA[idx - 1]);
    }
  };
  var fecharModal = function fecharModal() {
    if (abrirModalImpressao !== undefined) {
      abrirModalImpressao.value = false;
    } else {
      setAbrirModalImpressao(false);
    }
  };
  var confirmLabel = strings && strings.confirmar ? strings.confirmar : strings.imprimir;
  return /*#__PURE__*/_react["default"].createElement(_core.SttModal, {
    title: strings.impressaoImagens.mensagemImprimir,
    open: true,
    maxWidth: "xs",
    outModalClose: fecharModal,
    iconClose: fecharModal,
    fullWidth: true
  }, /*#__PURE__*/_react["default"].createElement(_core.SttGrid, {
    className: classes.modalContent
  }, /*#__PURE__*/_react["default"].createElement(_core.SttGrid, {
    container: true,
    spacing: 3
  }, /*#__PURE__*/_react["default"].createElement(_core.SttGrid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react["default"].createElement(_core.SttGrid, {
    className: classes.tituloMensagem
  }, strings.impressaoImagens.mensagemOpcaoImpressao), /*#__PURE__*/_react["default"].createElement(_core.SttGrid, {
    className: classes.previewWrapper
  }, /*#__PURE__*/_react["default"].createElement("img", {
    src: paginaImagens[quantidadeImagens],
    className: classes.previewImagens
  })), /*#__PURE__*/_react["default"].createElement(_core.SttGrid, {
    className: classes.linhaControle
  }, /*#__PURE__*/_react["default"].createElement(_core.SttGrid, {
    className: classes.grupoBotoes
  }, /*#__PURE__*/_react["default"].createElement(_core.SttButton, {
    type: "button",
    variant: "outlined",
    color: "primary",
    className: classes.botaoCircular,
    onClick: decrementar,
    disabled: indiceAtual() === 0 || loading
  }, /*#__PURE__*/_react["default"].createElement(_Remove["default"], null)), /*#__PURE__*/_react["default"].createElement(_core.SttGrid, {
    className: classes.box
  }, quantidadeImagens), /*#__PURE__*/_react["default"].createElement(_core.SttButton, {
    type: "button",
    variant: "outlined",
    color: "primary",
    className: classes.botaoCircular,
    onClick: incrementar,
    disabled: indiceAtual() === OPCOES_IMAGENS_POR_PAGINA.length - 1 || loading
  }, /*#__PURE__*/_react["default"].createElement(_Add["default"], null))), /*#__PURE__*/_react["default"].createElement(_core.SttGrid, null, /*#__PURE__*/_react["default"].createElement(_core.SttButton, {
    type: "button",
    variant: "contained",
    color: "primary",
    className: classes.botaoConfirmar,
    disabled: loading,
    onClick: imprimirFn
  }, confirmLabel)))))));
};
var _default = SttModalImpressao;
exports["default"] = _default;